module.exports = __webpack_public_path__ + "img/slider-arrow-next.17ec5b96d4da051328970aa39ef41436.svg";